import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { AiTwotoneCalendar } from "react-icons/ai";
import { HiTrendingUp } from "react-icons/hi";
import { TbList } from "react-icons/tb";
import { Link, NavLink } from "react-router-dom";
import { BsFacebook, BsInstagram, BsLinkedin } from "react-icons/bs";

const sideBar = () => {
  return (
    <>
      <Flex
        direction="column"
        justifyContent="space-between"
        w="16%"
        h="90vh"
        borderRight="1px solid #c7c7c7"
      >
        <Box mt="15px" w="100%">
          
            <Flex
              w="90%"
              borderRadius="4px"
              pl="5px"
              alignItems="center"
              gap="5px"
              m="auto"
              backgroundColor="#2C4BFF"
              color="white"
              h="33px"
              _hover={{ cursor: "pointer" }}
            >
              <AiTwotoneCalendar />
              <Text fontSize="sm" fontWeight="semibold">
                Calendar
              </Text>
            </Flex>
          
          <Box mt="10px">
            
              <Flex
                w="90%"
                borderRadius="4px"
                pl="5px"
                alignItems="center"
                gap="5px"
                m="auto"
                h="33px"
                _hover={{
                  cursor: "pointer",
                  backgroundColor: "#D6D6D6",
                }}
              >
                <HiTrendingUp color="#c7c7c7" />
                <Text fontSize="sm" fontWeight="semibold">
                  Campaigns
                </Text>
              </Flex>
            
          </Box>
          <Box mt="10px">
            
              <Flex
                w="90%"
                borderRadius="4px"
                pl="5px"
                alignItems="center"
                gap="5px"
                m="auto"
                h="33px"
                _hover={{
                  cursor: "pointer",
                  backgroundColor: "#D6D6D6",
                }}
              >
                <TbList color="#c7c7c7" />
                <Text fontSize="sm" fontWeight="semibold">
                  Queues
                </Text>
              </Flex>
              <NavLink to="/facebook">
              <Flex
                w="80%"
                borderRadius="4px"
                pl="5px"
                alignItems="center"
                gap="5px"
                m="auto"
                ml="40px"
                h="33px"
                _hover={{
                  cursor: "pointer",
                  backgroundColor: "#D6D6D6",
                }}
              >
                <BsFacebook />
                <Text fontSize="sm" fontWeight="semibold">
                  Facebook
                </Text>
              </Flex>
            </NavLink>
            <NavLink to="/instagram">
              <Flex
                w="80%"
                borderRadius="4px"
                pl="5px"
                alignItems="center"
                gap="5px"
                m="auto"
                ml="40px"
                h="33px"
                _hover={{
                  cursor: "pointer",
                  backgroundColor: "#D6D6D6",
                }}
              >
                <BsInstagram />
                <Text fontSize="sm" fontWeight="semibold">
                  Instagram
                </Text>
              </Flex>
            </NavLink>
            <NavLink to="/linkedin">
              <Flex
                w="80%"
                borderRadius="4px"
                pl="5px"
                alignItems="center"
                gap="5px"
                m="auto"
                ml="40px"
                h="33px"
                _hover={{
                  cursor: "pointer",
                  backgroundColor: "#D6D6D6",
                }}
              >
                <BsLinkedin />
                <Text fontSize="sm" fontWeight="semibold">
                  LinkedIn
                </Text>
              </Flex>
            </NavLink>
            
          </Box>
        </Box>
        <Box mb="10px">
         <NavLink to="/channels">
            <Flex
              justifyContent="center"
              alignItems="center"
              w="90%"
              border="1px solid #c7c7c7"
              borderRadius="4px"
              pl="5px"
              gap="5px"
              m="auto"
              h="40px"
              _hover={{
                cursor: "pointer",
                border: "1px solid grey",
              }}
            >
              <Text color="grey" fontSize="sm" fontWeight="semibold">
                Manage Channels
              </Text>
            </Flex>
            </NavLink>
        </Box>
      </Flex>
    </>
  );
};

export default sideBar;
